/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import createSagasMiddlerware from 'redux-saga';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import reducers from './reducers';
import sagas from './sagas';
import { initialState } from './reducers/slipReducer';
const sagasMiddleware = createSagasMiddlerware();
const migrations = {
    0: (state) => (Object.assign(Object.assign({}, state), { slip: initialState }))
};
const persistConfig = {
    version: 0,
    key: 'byo',
    storage,
    whitelist: ['auth'],
    // @ts-expect-error - can't type createMigrate without some patch of sorts https://github.com/rt2zz/redux-persist/issues/1065
    migrate: createMigrate(migrations),
};
const persistedReducer = persistReducer(persistConfig, reducers);
const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
const enhancer = composeEnhancers(applyMiddleware(sagasMiddleware));
const store = createStore(persistedReducer, enhancer);
sagasMiddleware.run(sagas);
const persistor = persistStore(store);
export { store, persistor };
